import { ReactComponent as PlayersLoungeLogo } from "../../assets/logo/players-lounge-logo.svg"
import './live-badge.css'
import { Side } from "../../helpers/overlay-settings"

export const LiveBadge = ({ side }: { side: Side }) => {
  return (
    <div className={`live_badge__wrapper live_badge__wrapper--${side}`}>
      <span className="live_badge__dot" />
      <span className="live_badge__label pl-fontS">LIVE on</span>
      <PlayersLoungeLogo className="live_badge__logo" />
    </div>
  )
}
